<template>
  <div>
    <v-row class="ml-2 pb-4">
      <span class="PaddingItemPerPage d-flex mt-4">
        <label class="" style="margin-top: -2px;">Rows Per Page</label>
        <v-select v-model="localPageSize" :items="pageSizes" class="custom-pagination-ui" @update:modelValue="handlePageSizeChange"
        variant="outlined" density="compact" style="margin-left: 120px;margin-top:-10px;position:absolute;"></v-select>
      </span>
      <span class="item-selected" :style="totalCount > 9999 ? 'left:24% !important;' : ''">
        <span v-if="selected?.length == 1">{{ selected?.length }} Item Selected</span>
        <span v-if="selected?.length > 1">{{ selected?.length }} Items Selected</span>
      </span>
      <v-spacer></v-spacer>
      <div class="d-flex">
        <span :class="totalCount > 9999 ? 'pt-2 mt-3 mr-1' : 'pt-2 mt-3 mr-1'" v-if="totalCount > 0">
          Showing Results {{ (page - 1) * pageSize + 1 }} - {{ Math.min(page * pageSize, totalCount) }} of {{ totalCount }}
        </span>
        <span class="PaddingItemPerPage mr-3" :style="totalPages > 7 ? 'min-width: 380px' : 'auto'">
          <v-pagination :modelValue="page" :length="totalPages" total-visible="7" class="custom-pagination-ui"
          @update:modelValue="handlePageChange" density="compact" rounded="circle"></v-pagination>
        </span>
      </div>
    </v-row>
  </div>
</template>

<script>
import { h } from 'vue';

export const defaultPageSize = 50;
export const defaultPageSizes = [50, 100, 200];

export default {
  props: {
    pageSize: {
      type: Number,
      default: defaultPageSize
    },
    pageSizes: {
      type: Array,
      default: () => defaultPageSizes
    },
    totalCount: Number,
    selected: Array,
    page: Number,
    totalPages: Number,
    handlePageSizeChange: Function,
    handlePageChange: Function
  },
  data() {
    return {
      localPageSize: this.pageSize,
    };
  },
  methods: {
    handlePageSizeChange(newValue) {
      this.localPageSize = newValue;
      this.$emit('update:pageSize', newValue);
    },
    handlePageChange(newValue) {
      this.$emit('update:page', newValue);
    }
  },
  watch: {
    pageSize(newVal) {
      this.localPageSize = newVal;
    }
  }
}
</script>

<style scoped>
/* Add your styles here */
</style>